/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { db } from "../../firebase-config";
import { storage } from "../../firebase-config";
import {
  ref as ref_storage,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { useParams, Link, useLocation, useNavigate } from "react-router-dom";
import { ref, onValue, update, get, child, set } from "firebase/database";
import "./AddImage.css";
import { ToastContainer, toast } from "react-toastify";
import CryptoJS from "crypto-js";
import { logPatientUploadTech, logPatientInfoUpdateTech } from "../AddPatientTech/TechAuditLogs";
import JSZip from "jszip";

// Helper function to check if a DICOM file should be excluded from ZIP creation
// Excludes dicom-seg-[1-9].dcm and dicom-sr-[1-9].dcm files
const shouldExcludeFromZip = (filename) => {
  const lowerFilename = filename.toLowerCase();
  
  // Check for dicom-seg-[1-9].dcm pattern
  const dicomSegPattern = /^dicom-seg-[1-9]\.dcm$/;
  if (dicomSegPattern.test(lowerFilename)) {
    console.log(`[ZIP Filter] Excluding DICOM-SEG file: ${filename}`);
    return true;
  }
  
  // Check for dicom-sr-[1-9].dcm pattern
  const dicomSrPattern = /^dicom-sr-[1-9]\.dcm$/;
  if (dicomSrPattern.test(lowerFilename)) {
    console.log(`[ZIP Filter] Excluding DICOM-SR file: ${filename}`);
    return true;
  }
  
  return false;
};

// Encryption & Decryption logic
const encryptData = (data) => {
  const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
  return CryptoJS.AES.encrypt(data, secretKey).toString();
};

// ** Function to decrypt encrypted data
const decryptData = (data) => {
  const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
  try {
    const bytes = CryptoJS.AES.decrypt(data, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.warn("Decryption failed, returning original data.");
    return data;
  }
};

const decryptDataIfNeeded = (data) => {
  if (typeof data === "string") {
    const decryptedData = decryptData(data);
    return decryptedData && /^[\x00-\x7F]*$/.test(decryptedData)
      ? decryptedData
      : data;
  }
  return data;
};

// Helper function to reset progress state
const resetProgressState = (setUploadProgress, setTotalBytes, setUploadedBytes) => {
  setUploadProgress(0);
  setTotalBytes(0);
  setUploadedBytes(0);
};

// Helper function to calculate total bytes for all uploads
const calculateTotalUploadBytes = (state) => {
  let total = 0;
  
  // Add 3D file size
  if (state.selectedGltfFile) {
    total += state.selectedGltfFile.size;
  }
  
  // Add report file size
  if (state.selectedReportFile) {
    total += state.selectedReportFile.size;
  }
  
  // Add DICOM folder files size (only original files, ZIP is handled separately)
  if (state.selectedDicomFolderFiles && state.selectedDicomFolderFiles.length > 0) {
    const dicomFolderSize = state.selectedDicomFolderFiles.reduce((sum, file) => sum + file.size, 0);
    total += dicomFolderSize;
    // Don't add ZIP size here - it's handled in the upload function
  }
  
  return total;
};

// Initial state for patient and upload data
const initialState = {
  encryptedPatientId: "",
   DoctorAssigned: "",
   FullName: "",
   ID: "",
   Role: "",
   Age: "",
   Dicom_3D: "",
   Dicom_Report: "",
   FolderPath: "",
   Type_of_CT: "",
   Type_of_Dicom_Data: "",
   Gender: "",
   Refered_By_Doctor: "",
   selectedGltfFile: null,
   selectedDicomFolderFiles: [],
   selectedReportFile: null,
   Modality: "",
 };

 // Helper function to check if modality is XRay
const checkIfXRayModality = (modalityValue) => {
  if (!modalityValue) return false;
  const modalityUpper = modalityValue.toUpperCase().trim();
  return modalityUpper === "XRAY";
};

// Helper function to find report URL with priority-based lookup
const findReportURL = (patientData, uploads) => {
  let foundReportURL = "";
  let reportSource = "";

  // PRIORITY 1: Find report in uploads - Check LATEST scan first
  if (uploads && uploads.length > 0) {
    // Sort uploads by timestamp or scan number to get the latest
    const sortedUploads = [...uploads].sort((a, b) => {
      // Try to extract scan numbers (e.g., "Scan 1", "Scan 2")
      const getNumber = (upload) => {
        const match = upload.uploadID?.match(/\d+/);
        return match ? parseInt(match[0]) : 0;
      };
      return getNumber(b) - getNumber(a); // Descending order (latest first)
    });

    // Check latest scan first
    for (const upload of sortedUploads) {
      const reportURL = upload.Dicom_ReportURL;
      if (reportURL && reportURL !== "Not Uploaded" && reportURL !== "NA" && reportURL.trim() !== "") {
        foundReportURL = reportURL;
        reportSource = `Found in ${upload.uploadID || "Upload"}`;
        break;
      }
    }
  }

  // PRIORITY 2: Fallback to main patient node for report (both Version 03 and legacy)
  if (!foundReportURL && patientData) {
    const mainReportURL = patientData.Dicom_ReportURL;
    if (mainReportURL && mainReportURL !== "Not Uploaded" && mainReportURL !== "NA" && mainReportURL.trim() !== "") {
      foundReportURL = mainReportURL;
      reportSource = "Found in Main Patient Node";
    }
  }

  // PRIORITY 3: No report found anywhere
  if (!foundReportURL) {
    reportSource = "Not Available";
  }

  return { foundReportURL, reportSource };
};

function AddImage() {
  // State variables for managing patient data, uploads, and UI interactions
  const [state, setState] = useState(initialState);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [totalBytes, setTotalBytes] = useState(0);
  const [uploadedBytes, setUploadedBytes] = useState(0);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
   const [selectedFileType, setSelectedFileType] = useState("");
   const [buttonLabel, setButtonLabel] = useState("Add");
   const [modality, setModality] = useState("");
   const [typeOfData, setTypeOfData] = useState("");
   const navigate = useNavigate();
   const location = useLocation();
   const fileInputRef = useRef(null);
   const page = new URLSearchParams(location.search).get("page");
   //const [uploads, setUploads] = useState([]); // Array to manage multiple uploads
   const [selectedUploadID, setSelectedUploadID] = useState(null);
   const [uploads, setUploads] = useState([]); // Array to manage multiple uploads
   const [showUploadModal, setShowUploadModal] = useState(false);
   const [typeOfCTCustom, setTypeOfCTCustom] = useState("");
  const [originalCustomValue, setOriginalCustomValue] = useState(""); // Store original custom value  
   const [selectedDicomFolderName, setSelectedDicomFolderName] = useState("");
   const [selected3DFileName, setSelected3DFileName] = useState("");
   const [selectedReportFileName, setSelectedReportFileName] = useState("");
   const [isEditing, setIsEditing] = useState(false); // For toggling edit mode
   const [editedData, setEditedData] = useState({});  // Temporary storage for editing
   const [loading, setLoading] = useState(true); // Track loading state
   const [patientData, setPatientData] = useState(null); // Store full patient data for report lookup
   const queryParams = new URLSearchParams(location.search);
   const fromPage = queryParams.get("from") || "Technician"; // Default is Technician if missing
 
    // ** Test types categorized by modality
   const testTypes = {
     CT: [  "CRANIAL PLAIN",
     "CHEST PLAIN & CONTRAST",
     "CERVICAL SPINE PLAIN",
     "CERVICAL SPINE WITH CONTRAST",
     "CHEST HR PLAIN",],
     
     MRI: [
         "BRAIN PLAIN",
         "BRAIN WITH CONTRAST",
         "CERVICAL SPINE PLAIN",
         "CERVICAL SPINE WITH CONTRAST",
         "ABDOMEN PLAIN",
       ],

    XRAY: [
       "CHEST PA VIEW",
       "CHEST AP VIEW",
       "ABDOMEN ERECT",
       "CERVICAL SPINE AP/LAT",
       "PELVIS AP",
     ],
   };
   
 
   const { FullName, Role, Refered_By_Doctor } = state;
   const { id } = useParams();
 
   const adminName1 = localStorage.getItem("adminName");
   const technicianName = localStorage.getItem("Name");
   const originalStateRef = useRef(initialState);
 
   // ** Fetch patient data and uploads data
  useEffect(() => {
   const fetchPatientAndUploadsData = async () => {
     if (!id || !adminName1) {
       console.warn("Missing required parameters: id or adminName1");
       return;
     }
 
     const patientRef = ref(
       db,
       `superadmin/admins/${adminName1}/patients/${id}`
     );
 
     onValue(
       patientRef,
       (snapshot) => {
         if (snapshot.exists()) {
           const patientData = snapshot.val();
 
           // Store full patient data for report lookup
           setPatientData(patientData);

           // Determine Version (default to "01" if missing)
           const version = patientData.Version || "01";
 
           // Decrypt common patient details
           const decryptedData = {
             FullName: decryptDataIfNeeded(patientData.FullName),
             Age: decryptDataIfNeeded(patientData.Age),
             ID: decryptDataIfNeeded(patientData.ID),
             Gender: decryptDataIfNeeded(patientData.Gender),
             Role: decryptDataIfNeeded(patientData.Role) || "N/A",
             Clinical_Textarea: decryptDataIfNeeded(
               patientData.Clinical_Textarea
             ),
             Clinical_Filepath: decryptDataIfNeeded(
               patientData.Clinical_Filepath
             ),
             Timestamp: patientData.Timestamp || "N/A",
           };
 
           // Update patient state
           setState((prevState) => ({
             ...prevState,
             ...decryptedData,
              encryptedPatientId: patientData.ID,
             FullName: decryptedData.FullName || "N/A",
             Age: decryptedData.Age || "N/A",
             ID: decryptedData.ID || "N/A",
             Gender: decryptedData.Gender || "N/A",
           }));
 
           // Prepare uploads array
           let uploadsArray = [];
 
           // Handle modern `uploads` node
           if (patientData.uploads && typeof patientData.uploads === "object") {
             uploadsArray = Object.keys(patientData.uploads || {}).map((key) => ({
               uploadID: key,
               ...patientData.uploads[key],
               Dicom_3D: decryptDataIfNeeded(patientData.uploads[key]?.Dicom_3D),
               Dicom_3DURL: decryptDataIfNeeded(
                 patientData.uploads[key]?.Dicom_3DURL
               ),
               FolderPath: decryptDataIfNeeded(
                 patientData.uploads[key]?.FolderPath
               ),
               Path3D: decryptDataIfNeeded(patientData.uploads[key]?.Path3D),
               Dicom_Report: decryptDataIfNeeded(
                 patientData.uploads[key]?.Dicom_Report
               ),
               Dicom_ReportURL: decryptDataIfNeeded(
                 patientData.uploads[key]?.Dicom_ReportURL
               ),
               PathReport: decryptDataIfNeeded(
                 patientData.uploads[key]?.PathReport
               ),
               Type_of_Dicom_Data:
                 decryptDataIfNeeded(
                   patientData.uploads[key]?.Type_of_Dicom_Data
                 ) || "N/A",
               StudyDate: patientData.uploads[key]?.StudyDate || "Not Set",
               Modality: patientData.uploads[key]?.Modality || "Not Selected",
               uploadtimetamp:
                 patientData.uploads[key]?.uploadtimetamp || "Not Available",
             }));
           }
 
           // Handle legacy fields for older versions (01 and 02)
           if (version === "01" || version === "02") {
             // Check if legacy fields exist
             const legacyData = {
               Dicom_3D: decryptDataIfNeeded(patientData.Dicom_3D),
               Dicom_3DURL: decryptDataIfNeeded(patientData.Dicom_3DURL),
               FolderPath: decryptDataIfNeeded(patientData.FolderPath),
               Path3D: decryptDataIfNeeded(patientData.Path3D),
               Dicom_Report: decryptDataIfNeeded(patientData.Dicom_Report),
               Dicom_ReportURL: decryptDataIfNeeded(patientData.Dicom_ReportURL),
               PathReport: decryptDataIfNeeded(patientData.PathReport),
               Type_of_Dicom_Data: decryptDataIfNeeded(
                 patientData.Type_of_Dicom_Data
               ) || "N/A",
               StudyDate: patientData.StudyDate || "Not Set",
               Modality: patientData.Modality || "Not Selected",
               uploadtimetamp: patientData.Timestamp || "Not Available",
             };
 
             // Add legacy data to uploadsArray if any fields exist
             if (
               legacyData.Dicom_3D ||
               legacyData.Dicom_Report ||
               legacyData.FolderPath
             ) {
               uploadsArray.push({
                 uploadID: "legacy_upload", // Unique ID for legacy data
                 ...legacyData,
               });
             }
           }
 
           // Update uploads state
           setUploads(uploadsArray);
 
         } else {
           console.warn("No patient data found for this ID.");
           setState(initialState);
           setUploads([]);
         }
       },
       (error) => {
         console.error("Error fetching patient data:", error);
       }
     );
  };

  fetchPatientAndUploadsData();
}, [id, adminName1]);

  
// Prefill modality & type when modal opens for editing
 useEffect(() => {
   if (showUploadModal && selectedUploadID) {
     const sel = uploads.find((u) => u.uploadID === selectedUploadID);
     
     if (sel) {
      
       setModality(sel.Modality || "");
       
       // if custom CT type stored
       const rawTestType = sel.Type_of_CT || sel.Type_of_Dicom_Data || sel.Type_of_Data || "";
       const savedTestType = rawTestType && rawTestType.toUpperCase() !== "N/A" ? rawTestType : "";

       
       if (savedTestType) {
         const stdList = (testTypes[sel.Modality] || []).map((t) => t.toUpperCase());
         
         if (stdList.includes(savedTestType.toUpperCase())) {
           setTypeOfData(savedTestType);
           setState(prev => ({ ...prev, Type_of_Dicom_Data: savedTestType }));
           setTypeOfCTCustom("");
         } else {
          console.log("DEBUG: Setting typeOfCTCustom to:", savedTestType);
          setTypeOfCTCustom(savedTestType);
          setOriginalCustomValue(savedTestType); // Store original custom value
          setTypeOfData(savedTestType);  // Set to the actual custom value
          setState(prev => ({ ...prev, Type_of_Dicom_Data: savedTestType, customTypeOfDicomData: savedTestType }));
         }
       } else {
         setTypeOfData("");
         setTypeOfCTCustom("");
       }
     }
   }
 }, [showUploadModal, selectedUploadID, uploads]);

  // add for reset the modal
 
  // Reset modal fields helper
  const resetModalFields = () => {
     // Clear fields only when creating a new upload (no selected ID)
     if (!selectedUploadID) {
       setModality("");
       setTypeOfData("");
     }
    setTypeOfCTCustom("");
    setState((prevState) => ({
      ...initialState,
      FullName: prevState.FullName,
      Age: prevState.Age,
      Gender: prevState.Gender,
      ID: prevState.ID,
      ClinicalHistory: prevState.ClinicalHistory,
      Clinical_Textarea: prevState.Clinical_Textarea, // Preserve clinical history - Viniith Changed This
      Clinical_Filepath: prevState.Clinical_Filepath, // Preserve clinical file path - Viniith Changed This
    }));
  };
 
 
     // ** Format timestamp in DD/MM/YYYY HH:mm:ss format
   const formatTimestamp = () => {
     const now = new Date();
     const day = String(now.getDate()).padStart(2, "0"); // Ensure 2-digit day
     const month = String(now.getMonth() + 1).padStart(2, "0"); // Ensure 2-digit month
     const year = now.getFullYear();
     const hours = String(now.getHours()).padStart(2, "0"); // Ensure 2-digit hour
     const minutes = String(now.getMinutes()).padStart(2, "0"); // Ensure 2-digit minute
     const seconds = String(now.getSeconds()).padStart(2, "0"); // Ensure 2-digit second
   
     return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
   };
   
 
 
   
   // Handle opening modal for Add or Update
   const handleOpenModal = (uploadID = null) => {
     setShowUploadModal(true); 
     setSelectedUploadID(uploadID); 
    
     if (uploadID) {
       // Update Mode: Load existing upload data
       const selectedUpload = uploads.find((upload) => upload.uploadID === uploadID);
       if (selectedUpload) {
         setState((prevState) => ({
           ...prevState,
           ...selectedUpload, 
           selectedDicomFolderFiles: [],
           selectedReportFile: null,
           Type_of_Dicom_Data: selectedUpload.Type_of_Dicom_Data || selectedUpload.Type_of_CT || "", // Set for dropdown
         }));
         setModality(selectedUpload.Modality || ""); 
         setTypeOfData(selectedUpload.Type_of_Dicom_Data || selectedUpload.Type_of_CT || ""); // Use correct field
         setTypeOfCTCustom(""); 
       }
     } else {
       // Add Mode: Reset state to initial values but preserve patient-specific details
       setState((prevState) => ({
         ...prevState,
         ...initialState, 
         FullName: prevState.FullName,
         Age: prevState.Age,
         Gender: prevState.Gender,
         ID: prevState.ID,
         ClinicalHistory: prevState.ClinicalHistory,
         Clinical_Textarea: prevState.Clinical_Textarea, // Viniith Changed This
         Clinical_Filepath: prevState.Clinical_Filepath, // Viniith Changed This
       }));
       setModality("XRAY"); // Default to XRAY for new uploads
       setTypeOfData("");
       setTypeOfCTCustom("");
     }
   };
   
   useEffect(() => {
     if (selectedUploadID) {
       const selectedUpload = uploads.find(
         (upload) => upload.uploadID === selectedUploadID
       );
       if (selectedUpload) {
         setState((prevState) => ({
           ...prevState, // Preserve existing patient details
           Type_of_CT: selectedUpload.Type_of_CT || "",
           Dicom_3D: selectedUpload.Dicom_3D || "",
           Dicom_3DURL: selectedUpload.Dicom_3DURL || "",
           FolderPath: selectedUpload.FolderPath || "",
           Path3D: selectedUpload.Path3D || "",
           Dicom_Report: selectedUpload.Dicom_Report || "",
           Dicom_ReportURL: selectedUpload.Dicom_ReportURL || "",
           PathReport: selectedUpload.PathReport || "",
           StudyDate: selectedUpload.StudyDate || "",
           Modality: selectedUpload.Modality || "",
           uploadtimetamp: selectedUpload.uploadtimetamp || "",
         }));
       }
       // Set Modality and Type of Data for dropdowns
       setModality(selectedUpload.Modality || ""); // Pre-fill Modality dropdown
       setTypeOfData(selectedUpload.Type_of_Dicom_Data || selectedUpload.Type_of_CT || ""); // Pre-fill Type of Data dropdown
     } 
     else {
       // Reset the form but preserve patient details
       setState((prevState) => ({
         ...prevState,
         Type_of_CT: "",
         selectedGltfFile: null,
         selectedDicomFolderFiles: [],
         selectedReportFile: null,
       }));
    }
  }, [selectedUploadID, uploads]);

  useEffect(() => {
    let isAdding = false;
    let isUpdating = false;

     if (selectedUploadID) {
       // **Update Mode:** An existing upload is selected
       // If any relevant field has been modified, set to updating
       if (
         state.Type_of_CT !== "" ||
         state.selectedGltfFile ||
         (state.selectedDicomFolderFiles &&
           state.selectedDicomFolderFiles.length > 0) ||
         state.selectedReportFile
       ) {
         isUpdating = true;
       }
     } else {
       // **Add Mode:** No upload is selected, creating a new upload
       // If any relevant field is filled, set to adding
       if (
         state.Type_of_CT ||
         state.selectedGltfFile ||
         (state.selectedDicomFolderFiles &&
           state.selectedDicomFolderFiles.length > 0) ||
         state.selectedReportFile ||
         state.Gender
       ) {
         isAdding = true;
       }
     }
 
     // **Set the Button Label Based on the Mode**
     if (isUpdating) {
       setButtonLabel("Update"); 
     } else if (isAdding) {
       setButtonLabel("Add"); 
     } else {
       setButtonLabel("Save"); 
     }
   }, [state, selectedUploadID, id]);
 
   // New useEffect to open file dialog when file type is selected
   useEffect(() => {
     if (selectedFileType) {
       fileInputRef.current?.click();
     }
   }, [selectedFileType]);
 
   const handleInputChange = (e) => {
     const { name, value } = e.target;
     setState({ ...state, [name]: value });
   };
   // Handle age input with numeric-only enforcement
  //deepa added bugs
  // const handleAgeInputChange = (e) => {
  //   let value = e.target.value;
  //   // Remove any non-numeric characters
  //   value = value.replace(/[^0-9]/g, '');
    
  //   // Validate age range (0-150)
  //   const ageNum = parseInt(value);
  //   if (value === '' || (ageNum >= 0 && ageNum <= 150)) {
  //     setEditedData((prev) => ({ ...prev, Age: value }));
  //   }
  // };
  const handleAgeInputChange = (e) => {
    let value = e.target.value;
    // Remove any non-numeric characters
    value = value.replace(/[^0-9]/g, '');
    
    // Allow all numeric values to be typed (validation message will show for invalid ranges)
    setEditedData((prev) => ({ ...prev, Age: value }));
  };
   // **Helper Function to Get Current Date in DD/MM/YYYY Format**
   const getCurrentDate = () => {
     const now = new Date();
     const day = String(now.getDate()).padStart(2, "0"); // Day with leading zero
     const month = String(now.getMonth() + 1).padStart(2, "0"); // Month (0-indexed) with leading zero
     const year = now.getFullYear();
     return `${day}/${month}/${year}`; // Return formatted date
   };
   // Helper function to upload a single file
   const uploadFile = (file, storagePath) => {
     return new Promise((resolve, reject) => {
       if (!file) {
         resolve({ name: "Not Uploaded", url: "Not Uploaded" });
         return;
       }
 
       const fileRef = ref_storage(storage, storagePath);
       const uploadTask = uploadBytesResumable(fileRef, file);
 
       uploadTask.on(
         "state_changed",
         (snapshot) => {
           const progress = Math.floor(
             (snapshot.bytesTransferred / snapshot.totalBytes) * 100
           );
           setUploadProgress(progress); // Update progress state
         },
         (error) => {
           console.error("Upload error:", error);
           reject(error);
         },
         () => {
           getDownloadURL(uploadTask.snapshot.ref)
             .then((downloadURL) => {
               resolve({ name: file.name, url: downloadURL });
             })
             .catch((error) => {
               console.error("Error getting download URL:", error);
               reject(error);
             });
         }
       );
     });
   };
 
   const handleSaveClinicalHistory = async () => {
     if (!id || !adminName1) {
       toast.error("Patient ID or admin name is missing.", {
         position: "top-center",
       });
       return;
     }
 
     const patientRef = ref(
       db,
       `superadmin/admins/${adminName1}/patients/${id}`
     );
     try {
       await set(patientRef, {
         ...state,
         ClinicalHistory: state.ClinicalHistory,
       });
       toast.success("Clinical history updated successfully.", {
         position: "top-center",
       });
     } catch (error) {
       console.error("Error updating clinical history:", error);
       toast.error("Failed to update clinical history.", {
         position: "top-center",
       });
     }
   };
 
   const handleEdit = () => {
   setIsEditing(true);
   setEditedData({ Age: state.Age, Gender: state.Gender });
 };
 const handleCancel = () => {
   setIsEditing(false);
   setEditedData({});
 };
 
 const handleSave = async (e) => {
   e.preventDefault();
 
   const isDicomUpload = state.selectedDicomFolderFiles.length > 0;
   const is3DUpload = !!state.selectedGltfFile;
   const isReportUpload = !!state.selectedReportFile;
 
   if (isDicomUpload && (!modality || (!typeOfData && !typeOfCTCustom))) {
     toast.error(
       "For DICOM uploads, please select both Modality and Type of Data.",
       {
         position: "top-center",
       }
     );
     return;
   }
 
   if (!isDicomUpload && !is3DUpload && !isReportUpload) {
     toast.error("Please select at least one file to upload.", {
       position: "top-center",
     });
     return;
   }
 
   // 🔹 Step 1: Calculate total work and initialize progress
   const totalWorkBytes = calculateTotalUploadBytes(state);
   setTotalBytes(totalWorkBytes);
   resetProgressState(setUploadProgress, setTotalBytes, setUploadedBytes);
   setModalIsOpen(true);
   
   console.log(`handleSave: Total upload work calculated: ${(totalWorkBytes / 1024 / 1024).toFixed(2)}MB`);
 
   const finalTypeOfData = typeOfCTCustom || typeOfData;
 
   if (!id) {
     toast.error("Patient ID is missing. Cannot save data.", {
       position: "top-center",
     });
     return;
   }
 
   const uploadsRef = ref(
     db,
     `superadmin/admins/${adminName1}/patients/${id}/uploads`
   );
 
   const patientRef = ref(
     db,
     `superadmin/admins/${adminName1}/patients/${id}`
   );
 
   try {
     // Step 1: Handle legacy data migration
     const snapshot = await get(patientRef);
     let patientData = snapshot.val();
     let existingUploads = patientData?.uploads || {};
     const version = patientData?.Version || "01";
 
     if (version === "01" || version === "02") {
       const legacyUpload = {
         Dicom_3D: patientData.Dicom_3D || "",
         Dicom_3DURL: patientData.Dicom_3DURL || "",
         FolderPath: patientData.FolderPath || "",
         Path3D: patientData.Path3D || "",
         Dicom_Report: patientData.Dicom_Report || "",
         Dicom_ReportURL: patientData.Dicom_ReportURL || "",
         PathReport: patientData.PathReport || "",
         StudyDate: patientData.StudyDate || "",
         Type_of_Dicom_Data: patientData.Type_of_Dicom_Data || "",
         Modality: patientData.Modality || "",
         uploadtimetamp: patientData.Timestamp || "Not Available",
       };
 
       existingUploads = {
         "Scan 1": legacyUpload,
       };
 
       await update(patientRef, {
         uploads: existingUploads,
         Version: "03", // Update version to indicate migration
         Dicom_3D: null,
         Dicom_3DURL: null,
         FolderPath: null,
         Path3D: null,
         Dicom_Report: null,
         Dicom_ReportURL: null,
         PathReport: null,
         StudyDate: null,
         Type_of_Dicom_Data: null,
         Modality: null,
       });
     }
 
     let uploadKey = selectedUploadID;
     if (!uploadKey) {
       const snapshot = await get(uploadsRef);
       const uploadCount = snapshot.exists()
         ? Object.keys(snapshot.val()).length + 1
         : 1;
       uploadKey = `Scan ${uploadCount}`;
     }
 
     let existingUploadData = {};
     if (selectedUploadID) {
       const existingSnapshot = await get(child(uploadsRef, selectedUploadID));
       if (existingSnapshot.exists()) {
         existingUploadData = existingSnapshot.val();
       }
     }
 
     const baseStoragePath = `superadmin/admins/${adminName1}/patients/${id}`;
    //  let uploadData = {
    //    ...existingUploadData, // Preserve existing data
    //    uploadtimetamp: formatTimestamp(), // Update timestamp
    //  };
     let uploadData = {
      ...existingUploadData, // Preserve existing data
      Modality: modality || existingUploadData.Modality || "",
      Type_of_Dicom_Data: finalTypeOfData || existingUploadData.Type_of_Dicom_Data || "",

      StudyDate: getCurrentDate() || existingUploadData.StudyDate || "",
      FolderPath: existingUploadData.FolderPath || "",
      Dicom_3D: existingUploadData.Dicom_3D || "",
      Dicom_3DURL: existingUploadData.Dicom_3DURL || "",
      Path3D: existingUploadData.Path3D || "",
      Dicom_Report: existingUploadData.Dicom_Report || "",
      Dicom_ReportURL: existingUploadData.Dicom_ReportURL || "",
      PathReport: existingUploadData.PathReport || "",
      uploadtimetamp: formatTimestamp(), // Always update timestamp
    };
    
     let totalNewUploadSize = 0; // Initialize size tracker
 
     // Update fields for DICOM upload
     if (isDicomUpload) {
       uploadData.Modality = modality || existingUploadData.Modality || "";
       uploadData.Type_of_Dicom_Data =
         finalTypeOfData || existingUploadData.Type_of_Dicom_Data || "";
       uploadData.StudyDate = getCurrentDate();
     } else {
       uploadData.StudyDate = existingUploadData.StudyDate || "";
     }
 
     // Update 3D data if a new file is uploaded
     if (state.selectedGltfFile) {
       const dicom3DPath = `${baseStoragePath}/${state.selectedGltfFile.name}`;
       const dicom3DUpload = await uploadFile(state.selectedGltfFile, dicom3DPath);
       uploadData.Dicom_3D = dicom3DUpload.name || "";
       uploadData.Dicom_3DURL = encryptData(dicom3DUpload.url || "");
       uploadData.Path3D = encryptData(`${baseStoragePath}/`);
       totalNewUploadSize += state.selectedGltfFile.size;
     }
 
     // Update report data if a new file is uploaded
     if (state.selectedReportFile) {
       const reportPath = `${baseStoragePath}/${state.selectedReportFile.name}`;
       console.log("reportPath", reportPath);
       const reportUpload = await uploadFile(state.selectedReportFile, reportPath);
       uploadData.Dicom_Report = reportUpload.name || "";
       uploadData.Dicom_ReportURL = encryptData(reportUpload.url || "");
       uploadData.PathReport = encryptData(`${baseStoragePath}/`);

       totalNewUploadSize += state.selectedReportFile.size;
     }
 
     // Handle DICOM folder uploads with ZIP creation
     if (isDicomUpload) {
       console.log("Starting DICOM folder upload with ZIP creation");
       const startTime = Date.now();
      
      // Get folder name from the first file's path or use timestamp
      const folderName = state.selectedDicomFolderFiles[0]?.webkitRelativePath?.split("/")[0] || `folder_${Date.now()}`;
      const outerFolder = `folder_${Date.now()}`;
      const folderPath = `${baseStoragePath}/${outerFolder}/`;
      
      // Check if this is XRay modality
      const isXRayModality = checkIfXRayModality(modality);
      console.log(`uploadDicomFolder: Modality='${modality}', Is XRay: ${isXRayModality}`);
      
      // Step 1: Calculate total work (sum of all file sizes only)
      const totalFileBytes = state.selectedDicomFolderFiles.reduce((sum, file) => sum + file.size, 0);
      console.log(`Total DICOM files size: ${(totalFileBytes / 1024 / 1024).toFixed(2)}MB`);
      
      // Track uploaded bytes across all files
      let currentUploadedBytes = 0;
      const fileProgressMap = new Map();
      
      // Step 1: Upload all individual DICOM files to Firebase Storage
      console.log(`Uploading ${state.selectedDicomFolderFiles.length} DICOM files to storage`);
      
      let fileUploadPromises;
      
      if (isXRayModality) {
        console.log(`📁 XRay Upload: Organizing files into XRay folder structure`);
        
        // Group files by series (subfolder name)
        const seriesGroups = new Map();
        
        state.selectedDicomFolderFiles.forEach(file => {
          const relative = file.webkitRelativePath || file.name;
          const pathParts = relative.split('/');
          
          // Get series name (parent folder)
          let seriesName = "XRay_Series";
          if (pathParts.length > 2) {
            seriesName = pathParts[1];
          } else if (pathParts.length > 1) {
            seriesName = pathParts[0];
          }
          
          if (!seriesGroups.has(seriesName)) {
            seriesGroups.set(seriesName, []);
          }
          seriesGroups.get(seriesName).push(file);
        });
        
        console.log(`📊 Found ${seriesGroups.size} series:`, Array.from(seriesGroups.keys()));
        
        // Upload files with XRay structure
        fileUploadPromises = [];
        let globalIndex = 0;
        
        seriesGroups.forEach((files, seriesName) => {
          console.log(`📂 Processing series '${seriesName}' with ${files.length} files`);
          
          files.forEach((file, seriesIndex) => {
            const idx = globalIndex++;
            const xrayFolderName = `${seriesName}${seriesIndex + 1}`; // e.g., Knee1, Knee2
            const fileName = file.name;
            
            // Create path: baseStoragePath/outerFolder/seriesName/XRay1/file.dcm
            const fileStoragePath = `${baseStoragePath}/${outerFolder}/${seriesName}/${xrayFolderName}/${fileName}`;
            totalNewUploadSize += file.size;
            
            console.log(`📤 XRay upload: ${fileName} → ${seriesName}/${xrayFolderName}/`);
            
            fileProgressMap.set(idx, 0);
            
            const promise = new Promise((resolve, reject) => {
              const fileRef = ref_storage(storage, fileStoragePath);
              const uploadTask = uploadBytesResumable(fileRef, file);
              
              uploadTask.on(
                "state_changed",
                (snapshot) => {
                  const previousBytes = fileProgressMap.get(idx) || 0;
                  const currentFileBytes = snapshot.bytesTransferred;
                  const deltaBytes = currentFileBytes - previousBytes;
                  
                  fileProgressMap.set(idx, currentFileBytes);
                  currentUploadedBytes += deltaBytes;
                  
                  const fileUploadPercent = Math.min(60, (currentUploadedBytes / totalFileBytes) * 60);
                  setUploadProgress(Math.floor(fileUploadPercent));
                },
                (error) => {
                  console.error(`XRay upload failed [${fileName}]`, error);
                  reject(error);
                },
                async () => {
                  const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                  console.log(`✅ XRay uploaded: ${fileName}`);
                  resolve({ name: file.name, url: downloadURL });
                }
              );
            });
            
            fileUploadPromises.push(promise);
          });
        });
      } else {
        // Regular upload (non-XRay): preserve relative path
        fileUploadPromises = state.selectedDicomFolderFiles.map((file, idx) => {
          const relativePath = file.webkitRelativePath || file.name;
          const fileStoragePath = `${baseStoragePath}/${outerFolder}/${relativePath}`;
          totalNewUploadSize += file.size;
          
          fileProgressMap.set(idx, 0);
          
          return new Promise((resolve, reject) => {
            const fileRef = ref_storage(storage, fileStoragePath);
            const uploadTask = uploadBytesResumable(fileRef, file);
            
            uploadTask.on(
              "state_changed",
              (snapshot) => {
                const previousBytes = fileProgressMap.get(idx) || 0;
                const currentFileBytes = snapshot.bytesTransferred;
                const deltaBytes = currentFileBytes - previousBytes;
                
                fileProgressMap.set(idx, currentFileBytes);
                currentUploadedBytes += deltaBytes;
                
                const fileUploadPercent = Math.min(60, (currentUploadedBytes / totalFileBytes) * 60);
                setUploadProgress(Math.floor(fileUploadPercent));
              },
              (error) => {
                console.error(`File upload failed [${relativePath}]`, error);
                reject(error);
              },
              async () => {
                const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                console.log(`Uploaded file [${relativePath}]`);
                resolve({ name: file.name, url: downloadURL });
              }
            );
          });
        });
      }
      
      await Promise.all(fileUploadPromises);
       console.log("All DICOM files uploaded to storage");
       
       // Step 2: Create ZIP using JSZip
       const zip = new JSZip();
       console.log("Creating ZIP file with JSZip");
       
       // Filter out dicom-seg-[1-9].dcm and dicom-sr-[1-9].dcm files
       const filteredFiles = state.selectedDicomFolderFiles.filter(file => {
         const filename = file.name.toLowerCase();
         const shouldExclude = shouldExcludeFromZip(filename);
         return !shouldExclude;
       });
       
       console.log(`Filtered ${state.selectedDicomFolderFiles.length} files to ${filteredFiles.length} files (excluded DICOM-SEG/SR files)`);
      
      if (isXRayModality) {
        console.log(`📦 Creating ZIP with XRay structure for ${filteredFiles.length} files`);
        
        // Group files by series for ZIP (same logic as upload)
        const zipSeriesGroups = new Map();
        
        filteredFiles.forEach(file => {
          const relative = file.webkitRelativePath || file.name;
          const pathParts = relative.split('/');
          
          let seriesName = "XRay_Series";
          if (pathParts.length > 2) {
            seriesName = pathParts[1];
          } else if (pathParts.length > 1) {
            seriesName = pathParts[0];
          }
          
          if (!zipSeriesGroups.has(seriesName)) {
            zipSeriesGroups.set(seriesName, []);
          }
          zipSeriesGroups.get(seriesName).push(file);
        });
        
        // Add files to ZIP with XRay structure
        for (const [seriesName, files] of zipSeriesGroups.entries()) {
          for (let seriesIndex = 0; seriesIndex < files.length; seriesIndex++) {
            const file = files[seriesIndex];
            const xrayFolderName = `${seriesName}${seriesIndex + 1}`;
            const fileName = file.name;
            const zipPath = `${seriesName}/${xrayFolderName}/${fileName}`;
            
            try {
              const arrBuff = await file.arrayBuffer();
              zip.file(zipPath, arrBuff);
              console.log(`📦 Added to ZIP: ${zipPath}`);
            } catch (err) {
              console.error(`Error adding ${fileName} to ZIP:`, err);
              throw err;
            }
          }
        }
      } else {
        // Regular ZIP creation (non-XRay): use original relative paths
        for (const file of filteredFiles) {
          const relativePath = file.webkitRelativePath || file.name;
          try {
            const arrBuff = await file.arrayBuffer();
            zip.file(relativePath, arrBuff);
          } catch (err) {
            console.error(`Failed to read file for zipping [${relativePath}]`, err);
            throw err;
          }
        }
      } 
      
       console.log("Generating ZIP blob");
       
       // Generate ZIP blob with compression
       const zipBlob = await zip.generateAsync(
         { type: "blob", compression: "DEFLATE", compressionOptions: { level: 6 } },
         (metadata) => {
           // 🔹 Step 3: ZIP creation progress (60-90% range)
           const zipProgress = Math.floor(metadata.percent);
           
           // Calculate overall progress: 60-90% for ZIP creation
           const overallPercent = Math.min(90, 60 + (zipProgress * 30) / 100);
           setUploadProgress(Math.floor(overallPercent));
         }
       );
       
       console.log("ZIP generated", {
         zipSizeBytes: zipBlob.size,
         fileCount: state.selectedDicomFolderFiles.length,
       });
       
       // Check ZIP size and warn if too large
       const MB = 1024 * 1024;
       if (zipBlob.size / MB > 500) {
         console.warn(
           `ZIP is large (${(zipBlob.size / MB).toFixed(2)} MB). Browser memory limits may be reached.`
         );
       }
       
       // Step 3: Upload the ZIP file - save it one folder back (parent folder) from DICOM files
       const safeFolderName = folderName.replace(/[\/\\?#\[\]]/g, "_");
       const zipFileName = `${safeFolderName}.zip`;
       const zipStoragePath = `${baseStoragePath}/${outerFolder}/${zipFileName}`;
       
       const zipRef = ref_storage(storage, zipStoragePath);
       const zipTask = uploadBytesResumable(zipRef, zipBlob);
       
       console.log(`Uploading ZIP one folder back to ${zipStoragePath}`);
       
       // Wait for ZIP upload completion and track progress
       await new Promise((resolve, reject) => {
         zipTask.on(
           "state_changed",
           (snapshot) => {
             // 🔹 Step 4: ZIP upload progress (90-100% range)
             const zipUploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
             
             // Calculate overall progress: 90-100% for ZIP upload
             const overallPercent = Math.min(100, 90 + (zipUploadProgress * 10) / 100);
             setUploadProgress(Math.floor(overallPercent));
           },
           (error) => {
             console.error("ZIP upload failed", error);
             reject(error);
           },
           () => {
             setUploadProgress(100);
             console.log("ZIP upload finished");
             resolve();
           }
         );
       });
       
       // Step 4: Get download URL for ZIP
       let zipDownloadURL = "";
       try {
         zipDownloadURL = await getDownloadURL(zipRef);
         console.log("ZIP download URL obtained", zipDownloadURL);
       } catch (err) {
         console.warn("Failed to get ZIP download URL", err);
       }
       
       const elapsedTime = Date.now() - startTime;
      console.log(`DICOM folder upload with ZIP completed in ${elapsedTime}ms`);
      
      // Add ZIP file size to total storage calculation
      totalNewUploadSize += zipBlob.size;
      console.log(`Added ZIP size (${zipBlob.size} bytes) to total storage calculation`);
      
      // Update upload data with folder path only (ZIP stays in Storage only)
      uploadData.FolderPath = encryptData(folderPath);
      // ZIP is created and uploaded to Storage but not saved to Realtime Database
      
      setUploadProgress(100); // Complete progress
     } 
 
     // Deepa audit logs: removed premature handleUploadEvents invocation
 
     // Save updated data
     if (selectedUploadID) {
       await update(child(uploadsRef, uploadKey), uploadData);


     } else {
       await set(child(uploadsRef, uploadKey), uploadData);
     }
 
      //Viniith Added 18Feb
      const updatedStorageSize = await calculateTotalStorageSize(
        totalNewUploadSize
      );
      console.log(`Updated AdminStorageSize: ${updatedStorageSize} bytes`);

      // Update Firebase with new storage size
      if (updatedStorageSize) {
        const adminStorageRef = ref(
          db,
          `superadmin/admins/${adminName1}/AdminStorageSize`
        );
        await set(adminStorageRef, updatedStorageSize);
        console.log(
          `Successfully updated AdminStorageSize: ${updatedStorageSize}`
        );
      }

      toast.success(
        selectedUploadID ? "Upload updated successfully!" : "Upload saved successfully!",
        { position: "top-center" }
      );

      // Deepa audit logs: call handleUploadEvents to create audit logs for upload events
      console.log("🔄 Calling handleUploadEvents for upload audit logging...");
      await handleUploadEvents(modality);
      console.log("✅ handleUploadEvents completed");

     setState((prevState) => ({
       ...initialState,
       FullName: prevState.FullName,
       Age: prevState.Age,
       Gender: prevState.Gender,
       ID: prevState.ID,
       ClinicalHistory: prevState.ClinicalHistory,
       Clinical_Textarea: prevState.Clinical_Textarea, // Preserve clinical history text - Viniith Changed This
       Clinical_Filepath: prevState.Clinical_Filepath, // Preserve clinical file path - Viniith Changed This
     }));
 
     setShowUploadModal(false);
     setSelectedUploadID(null);
     setModalIsOpen(false);
   } catch (error) {
     console.error("Error saving upload data:", error);
     toast.error("Failed to save upload data. Please try again.", {
       position: "top-center",
     });
     setModalIsOpen(false);
   }
 };
 
    //Viniith  Added 18Feb
    const calculateTotalStorageSize = async (newUploadSize) => {
      let totalSize = newUploadSize;
  
      // Get the existing storage size from Firebase
      const adminStorageRef = ref(
        db,
        `superadmin/admins/${adminName1}/AdminStorageSize`
      );
      let currentStorageSize = 0;
  
      try {
        const adminStorageSnapshot = await get(adminStorageRef);
        if (adminStorageSnapshot.exists()) {
          currentStorageSize = parseFormattedSizeToBytes(
            adminStorageSnapshot.val()
          );
        }
      } catch (error) {
        console.error("Error fetching AdminStorageSize:", error);
      }
  
      // Calculate the new total size
      const updatedStorageSizeBytes = currentStorageSize + totalSize;
      const humanReadableSize = formatFileSize(updatedStorageSizeBytes);
  
      return humanReadableSize;
    };
  
    // Utility: format bytes -> human-readable string
    const formatFileSize = (size) => {
      if (size < 1024) return `${size}B`;
      if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)}KB`;
      if (size < 1024 * 1024 * 1024)
        return `${(size / (1024 * 1024)).toFixed(2)}MB`;
      return `${(size / (1024 * 1024 * 1024)).toFixed(2)}GB`;
    };
  
    // Utility: Convert formatted size back to bytes
    const parseFormattedSizeToBytes = (formatted) => {
      const sizePattern = /^(\d+(\.\d+)?)(KB|MB|GB|B)$/i;
      const match = formatted.match(sizePattern);
  
      if (!match) return 0;
  
      const value = parseFloat(match[1]);
      const unit = match[3].toUpperCase();
  
      switch (unit) {
        case "B":
          return value;
        case "KB":
          return value * 1024;
        case "MB":
          return value * 1024 * 1024;
        case "GB":
          return value * 1024 * 1024 * 1024;
        default:
          return 0;
      }
    };
   const handleEditSave = async () => {
     if (!editedData.Age && !editedData.Gender) {
       toast.error("At least one field must be updated.", { position: "top-center" });
       return;
     }
   
     // Create an updates object to hold only the modified fields
     const updates = {};
   
     // Add fields to updates object only if they are modified
     if (editedData.Age && editedData.Age !== state.Age) {
       updates.Age = encryptData(editedData.Age);
     }
     if (editedData.Gender && editedData.Gender !== state.Gender) {
       updates.Gender = encryptData(editedData.Gender);
     }
   
     // If no updates are detected, do nothing
     if (Object.keys(updates).length === 0) {
       toast.info("No changes detected.", { position: "top-center" });
       return;
     }

  // If no updates are detected, do nothing
  if (Object.keys(updates).length === 0) {
    toast.info("No changes detected.", { position: "top-center" });
    return;
  }

  // Update Firebase with only the modified fields
  try {
    const patientRef = ref(db, `superadmin/admins/${adminName1}/patients/${id}`);
    await update(patientRef, updates);

    // Update local state with new values
    setState((prevState) => ({
      ...prevState,
      ...editedData,
    }));

    toast.success("Patient information updated successfully.", {
      position: "top-center",
    });

    // Write audit log for successful patient info update
    console.log("🔄 Calling logPatientInfoUpdateTech for patient info edit...");
    try {
      await logPatientInfoUpdateTech({
        technicianName: technicianName || adminName1,
        patientId: state.encryptedPatientId,
        patientName: state.FullName,
        modality: state.Modality || "N/A",
        category: state.Type_of_Dicom_Data || "N/A",
        uploadedDicom: false,
        uploaded3D: false,
        uploadedReport: false,
        success: true,
      });
      console.log("✅ Patient info update audit log call completed");
    } catch (logErr) {
      console.error("❌ Failed to write patient info update audit log:", logErr);
    }

    // Exit editing mode
    setIsEditing(false);
    setEditedData({}); //deepa added bugs
  } catch (error) {
    console.error("Error updating patient info:", error);

    // Audit log for failed update
    console.log("🔄 Calling logPatientInfoUpdateTech for failed patient info edit...");
    try {
      await logPatientInfoUpdateTech({
        technicianName: technicianName || adminName1,
        patientId: state.encryptedPatientId,
        patientName: state.FullName,
        modality: state.Modality || "N/A",
        category: state.Type_of_Dicom_Data || "N/A",
        uploadedDicom: false,
        uploaded3D: false,
        uploadedReport: false,
        success: false,
        failureReason: error.message,
      });
      console.log("✅ Failed patient info update audit log call completed");
    } catch (logErr) {
      console.error("❌ Failed to write patient info update audit log:", logErr);
    }
       toast.error("Failed to update patient info. Please try again.", {
         position: "top-center",
       });
     }
   };
   
  
  
  
   const fileValidation = (file) => {
     if (!file) {
       toast.error("No file selected.", { position: "top-center" });
       return false;
     }
   
     const allowedExtensions = /(\.gltf|\.glb)$/i;
     if (!allowedExtensions.test(file.name)) {
       toast.error("Invalid File Type. Select only .gltf or .glb file.", {
         position: "top-center",
       });
       return false;
     }
   
     return true; // File is valid
   };
   
   const fileValidation1 = (e) => {
     const fileInput = e.target;
     const files = Array.from(fileInput.files);
     if (files.length === 0) {
       toast.error("No files selected", { position: "top-center" });
       return false;
     }
     if (!files[0].webkitRelativePath.includes("/")) {
       toast.error("Please select a folder", { position: "top-center" });
       fileInput.value = "";
       return false;
     }
     var isDICOMFolder = true;
     for (var i = 0; i < files.length; i++) {
       var file = files[i];
       var fileName = file.name.toLowerCase();
       var fileExtension = fileName.split(".").pop();
       if (fileExtension !== "dcm" && fileExtension !== "png" && fileExtension !== "jpg" && fileExtension !== "jpeg") {
         isDICOMFolder = false;
         break;
       }
     }
     if (!isDICOMFolder) {
      toast.error("Invalid folder contents. Only DICOM (.dcm), PNG (.png), and JPEG (.jpg/.jpeg) files are allowed", {
        position: "top-center",
       });
       fileInput.value = "";
       return false;
     }
     return true;
   };
 
 
   const handleFileSelect = (event) => {
     if (!selectedFileType) {
       setModalVisible(true);
       event.preventDefault();
     } else {
       // fileInputRef.current?.click();
     }
   };
 
   const handleTypeSelect = (type) => {
     setSelectedFileType(type);
     setModalVisible(false);
   };
 
   const handleCloseModal = () => {
     setSelectedFileType(null);
     setModalVisible(false);
   };
 
   const MRIuploadCount = async () => {
     const totalUploadsRef = ref(
       db,
       `superadmin/admins/${adminName1}/costing/MriUploads`
     );
     try {
       const snapshot = await get(totalUploadsRef);
       const currentUploads = Number(snapshot.val()) || 0;
       await set(totalUploadsRef, currentUploads + 1);
       console.log("Total MRI uploads incremented successfully.");
     } catch (error) {
       console.error("Failed to increment MRI uploads:", error);
     }
   };
 
   const CTupload = async () => {
     const totalUploadsRef = ref(
       db,
       `superadmin/admins/${adminName1}/costing/CTUploads`
     );
     try {
       const snapshot = await get(totalUploadsRef);
       const currentUploads = Number(snapshot.val()) || 0;
       await set(totalUploadsRef, currentUploads + 1);
       console.log("Total CT uploads incremented successfully.");
     } catch (error) {
       console.error("Failed to increment CT uploads:", error);
     }
   };
 
   const Xrayupload = async () => {
     const totalUploadsRef = ref(
       db,
       `superadmin/admins/${adminName1}/costing/XrayUploads`
     );
     try {
       const snapshot = await get(totalUploadsRef);
       const currentUploads = Number(snapshot.val()) || 0;
       await set(totalUploadsRef, currentUploads + 1);
       console.log("Total X-ray uploads incremented successfully.");
     } catch (error) {
       console.error("Failed to increment X-ray uploads:", error);
     }
   };
  // ** Increment upload counters
   const incrementTotalUploads = async () => {
     const totalUploadsRef = ref(
       db,
       `superadmin/admins/${adminName1}/costing/TotalUpload`
     );
     try {
       const snapshot = await get(totalUploadsRef);
       const currentUploads = Number(snapshot.val()) || 0;
       await set(totalUploadsRef, currentUploads + 1);
       console.log("Total uploads incremented successfully.");
     } catch (error) {
       console.error("Failed to increment total uploads:", error);
     }
   };
 
 // ** Track upload events
   const uploadEvents = async (selectedModality) => {
     try {
       console.log("Technician Name:", technicianName);
       console.log("Full Name:", FullName);
 
       if (!technicianName || !FullName) {
         console.error("TechnicianName or FullName is null or undefined");
         return;
       }
 
       const currentDate = new Date();
       const monthNames = [
         "JAN",
         "FEB",
         "MAR",
         "APR",
         "MAY",
         "JUN",
         "JUL",
         "AUG",
         "SEP",
         "OCT",
         "NOV",
         "DEC",
       ];
       const currentMonth = monthNames[currentDate.getMonth()];
       const currentYear = currentDate.getFullYear();
 
       const monthPath = `superadmin/admins/${adminName1}/costing/Upload_Events/${currentMonth} ${currentYear}`;
       const monthRef = ref(db, monthPath);
 
       console.log("Month Reference:", monthPath);
 
       const snapshot = await get(child(monthRef, "/"));
       const nextIndex = snapshot.exists() ? snapshot.size : 0;
 
       const uploadData = {
         TechnicianName: `${technicianName}`,
         PatientName: ` ${FullName}`,
         Modality: selectedModality,
         timeStamp: `${String(currentDate.getDate()).padStart(2, "0")}/${String(
           currentDate.getMonth() + 1
         ).padStart(2, "0")}/${currentDate.getFullYear()}, ${String(
           currentDate.getHours()
         ).padStart(2, "0")}:${String(currentDate.getMinutes()).padStart(
           2,
           "0"
         )}:${String(currentDate.getSeconds()).padStart(2, "0")}`,
       };
 
       await set(child(monthRef, `/${nextIndex}`), uploadData);
 
       console.log("Upload event added successfully.");
     } catch (error) {
       console.error("Failed to upload event:", error);
     }
   };
 
   // Deepa Audit Logs – 23 June 2025: patient data uploads 
const handleUploadEvents = async (modality) => {
  // Allow logging even when modality not selected (e.g., report-only uploads)
  const modalityLabel = modality || "N/A";
  
  let success = true;
  let failureReason = "";
  
  try {
    await incrementTotalUploads();

    if (modalityLabel === "MRI") {
      await MRIuploadCount();
    } else if (modalityLabel === "CT") {
      await CTupload();
    } else if (modalityLabel === "XRAY") {
      await Xrayupload();
    }

    await uploadEvents(modalityLabel);
    
    // deepa audit logs (success): write single audit entry after all uploads complete
    console.log("🔄 Calling logPatientUploadTech for successful upload...");
    await logPatientUploadTech({
      technicianName: technicianName || adminName1,
      patientId: state.encryptedPatientId,
      patientName: FullName,
      modality,
      category: state.Type_of_Dicom_Data || typeOfData,
      uploadedDicom: state.selectedDicomFolderFiles.length > 0,
      uploaded3D: !!state.selectedGltfFile,
      uploadedReport: !!state.selectedReportFile,
      success: true
    });
    console.log("✅ Upload audit log call completed");

    console.log("Upload events and counters updated successfully.");
  } catch (error) {
    console.error("Error updating upload events:", error);
    success = false;
    failureReason = error.message;
    
    // deepa audit logs (failure): write audit entry if any error occurs
    console.log("🔄 Calling logPatientUploadTech for failed upload...");
    await logPatientUploadTech({
      technicianName: technicianName || adminName1,
      patientId: state.encryptedPatientId,
      patientName: FullName,
      modality,
      category: state.Type_of_Dicom_Data || typeOfData,
      uploadedDicom: state.selectedDicomFolderFiles.length > 0,
      uploaded3D: !!state.selectedGltfFile,
      uploadedReport: !!state.selectedReportFile,
      success: false,
      failureReason
    });
    console.log("✅ Failed upload audit log call completed");
  }
};
  
 
   return (
     <div className="patient-data-portal">
     
 
       {/* Inline Progress Modal */}
       {modalIsOpen && (
         <div className="modal-overlay">
           <div className="modalUpload">
             <h2>Uploading...</h2>
             <div className="modal-upload-progress">
               <div className="bar" style={{ width: `${uploadProgress}%` }}></div>
             </div>
             <div className="progress-info">
              <span className="progress-percent">{uploadProgress}%</span>
            </div>
           </div>
         </div>
       )}
 
  {/* added by deepa 5feb for dynamic navigation */}
  <Link 
   to={fromPage === "AssignDoctor" 
      ? "/Admin/" 
      : fromPage === "Technician" 
        ? "/Technician/ListOfPatient" 
        : fromPage === "DoctorPanel"
          ? "/DoctorPanel"
          : -1
    }
   className="homeButton"
  >
   <span id="backText" className="backText">
     ← Back to {fromPage === "AssignDoctor" ? "Assign Doctor" : fromPage === "DoctorPanel" ? "Doctor Panel" : "Technician"}
    </span>
   <i id="backIcon" className="fas fa-long-arrow-alt-left fa-lg fa-2x"></i>
 </Link>
 
       {/* Sidebar and Header */}
       <div className="techsidebar"></div>
       <div className="top-nav">
         <h1
           style={{
             fontSize: "28px",
             textDecoration: "underline",
             marginRight: "15%",
             marginBottom: "2%",
           }}
         >
           {/* UPLOAD DATA */}
           Patient Data Portal
         </h1>
       </div>
   
       {/* Patient Information */}
       <div className="upload-container">
 <div className="patient-info">
   <div className="patient-info-left">
     <p>
       <strong>ID:</strong> {state.ID}
     </p>
  <p>
       <strong>Age:</strong>{" "}
       {isEditing ? (
        <>
          {/*deepa added bugs*/}
          <input
           type="text"
           name="Age"
           value={editedData.Age !== undefined ? editedData.Age : state.Age}
           onChange={handleAgeInputChange}
           onInput={(e) => {
             // Remove any non-numeric characters on input
             e.target.value = e.target.value.replace(/[^0-9]/g, '');
           }}
           maxLength="3"
           placeholder="Age (0-150)"
           className="edit-input"
           style={{
             borderColor: (editedData.Age && (parseInt(editedData.Age) < 0 || parseInt(editedData.Age) > 150 || isNaN(parseInt(editedData.Age)))) ? "red" : ""
           }}
         />
         {/* Age validation message */}
         {/*deepa added bugs*/}
         {editedData.Age && (
           <>
             {parseInt(editedData.Age) > 150 && (
               <span style={{ color: "red", fontSize: "11px", display: "block", marginTop: "2px" }}>
                 Maximum age is 150 years
               </span>
             )}
             {parseInt(editedData.Age) < 0 && (
               <span style={{ color: "red", fontSize: "11px", display: "block", marginTop: "2px" }}>
                 Age cannot be negative
               </span>
             )}
             {isNaN(parseInt(editedData.Age)) && editedData.Age !== "" && (
               <span style={{ color: "red", fontSize: "11px", display: "block", marginTop: "2px" }}>
                 Please enter a valid number
               </span>
             )}
           </>
         )}
        </>
      ) : (
        state.Age
      )}
     </p>
   </div>
   <div className="patient-info-right">
     <p>
       <strong>Name:</strong> {state.FullName}
     </p>
     <p>
       <strong>Gender:</strong>{" "}
       {isEditing ? (
     
         <select
   name="Gender"
   value={editedData.Gender || ""}
   onChange={(e) =>
     setEditedData((prev) => ({ ...prev, Gender: e.target.value }))
   }
   className="edit-input"
 >
   <option value="">Select</option>
   <option value="Male">Male</option>
   <option value="Female">Female</option>
   <option value="Other">Other</option>
 
 </select>
       ) : (
         state.Gender
       )}
     </p>
   </div>
 </div>
 
 
 <div className="edit-buttons-container">
   {isEditing ? (
     <>
       {/* Save Button */}
       <button
         onClick={handleEditSave}
         className="icon-btn save"
         title="Save Changes"
       >
         <i className="fas fa-check-circle"></i>
       </button>
 
       {/* Cancel Button */}
       <button
         onClick={handleCancel}
         className="icon-btn cancel"
         title="Cancel Changes"
       >
         <i className="fas fa-times-circle"></i>
       </button>
     </>
   ) : (
     <>
       {/* Edit Button */}
       <button
         onClick={handleEdit}
         className="edit-btn"
         title="Edit Information"
       >
         Edit
       </button>
     </>
   )}
 </div>
         {/* Insert Divider Here */}
         <div className="custom-divider"></div>
 
         {/* Clinical History Section */}
 <div className="clinical-history-container">
   <div className="clinical-history-content">
     <h3 className="clinical-history-title">Clinical History</h3>
     <div className="clinical-history-text">
       <p>{state.Clinical_Textarea || "No clinical notes available."}</p>
     </div>
     {state.Clinical_Filepath && (
       <div className="clinical-file-link">
         <a
           href={state.Clinical_Filepath}
           target="_blank"
           rel="noopener noreferrer"
         >
           View File
         </a>
       </div>
     )}
   </div>
 </div>
    {/* Insert Divider Here */}
         <div className="custom-divider"></div>
 
         {/* Uploaded Data Table */}
         <div className="upload-table-container">
           <div className="add-button-container">
 <button
   className="add-upload-btn"
   onClick={() => handleOpenModal()} // No uploadID, indicates new upload
 >
   + Add
 </button>  
           </div>
           
           <table className="upload-table">
             <thead>
               <tr>
                 <th>Study Date</th>
                 <th>Modality</th>
                 <th>Category</th>
                 <th>Scans</th>
                 {/* <th>3D Models</th> */}
                 <th>Reports</th>
                 <th>Action</th>
               </tr>
             </thead>
             <tbody>
               {uploads.length > 0 ? (
                 uploads.map((upload, index) => (
                   <tr key={index}>
                     <td>{upload.StudyDate || "Not Set"}</td>
                     <td>{upload.Modality || "Not Selected"}</td>
         
    <td>
           {upload.Type_of_CT?.trim() ||
           upload.Type_of_Dicom_Data?.trim() ||
           upload.Type_of_Data?.trim() ||
           "N/A"}
         </td>
   <td>
                       {upload.FolderPath && upload.FolderPath !== "Not Uploaded"
                         ? "Available"
                         : "N/A"}
                     </td>
                     {/* <td>
                       {upload.Dicom_3D && upload.Dicom_3D !== "Not Uploaded"
                         ? "Available"
                         : "Not Available"}
                     </td> */}
                     <td>
                      {(() => {
                        // Use priority-based report lookup
                        const { foundReportURL, reportSource } = findReportURL(patientData, uploads);
                        return foundReportURL ? "Available" : "N/A";
                      })()}
                    </td>
 
                     <td>
                       <button
                         className="update-btn"
                         title="Update Entry"
                         onClick={() => {
                           setShowUploadModal(true); // Open the modal
                           setSelectedUploadID(upload.uploadID); // Set selected upload ID
                           setState((prevState) => ({
                             ...prevState,
                             ...upload, 
                             selectedDicomFolderFiles: [],
                             selectedReportFile: null,
                             Type_of_Dicom_Data: upload.Type_of_Dicom_Data || upload.Type_of_CT || "", // Set for dropdown
                           }));
                           setModality(upload.Modality || ""); 
                           setTypeOfData(upload.Type_of_Dicom_Data || upload.Type_of_CT || ""); // Use correct field
                           setTypeOfCTCustom(""); 
                         }}
                       >
                         <div className="icon-container">
                           <i className="fas fa-sync-alt"></i>
                           <i className="fas fa-pencil-alt pencil-icon"></i>
                         </div>
                       </button>
                     </td>
                   </tr>
                 ))
               ) : (
                 <tr>
                   <td colSpan="7">No uploads available</td>
                 </tr>
               )}
             </tbody>
           </table>
         </div>
       </div>
 
       {/* Upload Modal */}
       {showUploadModal && (
         <div className="modal-overlay">
           <div className="upload-form-container">
             <h3>{selectedUploadID ? "Update Upload" : "New Upload"}</h3>
             <div className="form-group">
   <label>Modality</label>
 
 
 <select
   className="form-input"
   value={modality || ""} 
   onChange={(e) => {
     const selectedModality = e.target.value || null;
     setModality(selectedModality);
     setTypeOfData("");
     setTypeOfCTCustom("");
     setState((prevState) => ({
       ...prevState,
       Modality: selectedModality,
       Type_of_Dicom_Data: "",
     }));
   }}
 >
   <option value="">Select Modality</option>
   <option value="CT">CT</option>
   <option value="MRI">MRI</option>
   <option value="XRAY">X-Ray</option>
 </select>
 </div>
 
 <div className="form-group">
   <label>Type of Data</label>
  
 <select
   className="form-input"
   value={typeOfData || ""}
 
   onChange={(e) => {
     const selectedType = e.target.value || null; 
     setTypeOfData(selectedType); 
     if (selectedType === "Other") {
       // Clear custom value when selecting "Other" to enter new one
       setTypeOfCTCustom(""); // Clear for new input but keep originalCustomValue
       setState((prevState) => ({
         ...prevState,
         Type_of_Dicom_Data: "Other",
       }));
     } else if (selectedType === originalCustomValue) {
       // Selected the existing custom value
       setTypeOfCTCustom(selectedType); // Set it back
       setState((prevState) => ({
         ...prevState,
         Type_of_Dicom_Data: selectedType,
         customTypeOfDicomData: selectedType,
       }));
     } else {
       // Selected a standard option
       setTypeOfCTCustom(""); 
       setState((prevState) => ({
         ...prevState,
         Type_of_Dicom_Data: selectedType,
         customTypeOfDicomData: "",
       }));
     }
   }}
 >
   <option value="">Select Type</option>
  {(testTypes[modality] || []).map((type, index) => (
    <option key={index} value={type}>
      {type}
    </option>
  ))}
  {/* Show original custom value if it exists and is not in the standard list */}
  {originalCustomValue && !((testTypes[modality] || []).some(t => t.toUpperCase() === originalCustomValue.toUpperCase())) && (
    <option value={originalCustomValue}>{originalCustomValue}</option>
  )}
  <option value="Other">Other</option>
 </select>
 
 </div>
 
 {typeOfData === "Other" && (
   <div className="form-group">
     <label>Custom Type of Data</label>
     <input
       type="text"
       className="form-input"
       placeholder="Enter Custom Type of Data"
       // value={typeOfCTCustom}
       value={typeOfCTCustom || ""}
       onChange={(e) => {
         const customType = e.target.value || null; 
         setTypeOfCTCustom(customType); 
         setState((prevState) => ({
           ...prevState,
           // Type_of_CT: customType, 
           customTypeOfDicomData: customType,
         }));
       }}
     />
   </div>
 )}
  <form>
               {/* Upload DICOM Folder */}
               <div className="form-group">
                 <label>Scan </label> {/* deepaadded fix bugs */}
                 <input
                   type="file"
                   id="dicomFolderInput"
                   className="hidden-input"
                   webkitdirectory="true"
                   accept=".dcm,.png,.jpg,.jpeg"
                   onChange={(e) => {
                     if (fileValidation1(e)) {
                       const folderName = e.target.files[0]?.webkitRelativePath.split("/")[0];
                       setSelectedDicomFolderName(folderName); // Display folder name
                       setState((prev) => ({ ...prev, selectedDicomFolderFiles: [...e.target.files] })); // Store files
                     }
                   }}
                   
                 
                 />
 
 <label htmlFor="dicomFolderInput" className="browse-button">
       📄 Browse 
     </label>
     {selectedDicomFolderName && (
     <p className="file-name-display">Selected: {selectedDicomFolderName}</p>
   )}
               </div>
 
 {/* 3D Upload Section - COMMENTED OUT */}
 {/* <div className="form-group">
   <label>3D (.gltf/.glb):</label>
   <input
     type="file"
     id="dicom3DInput"
     className="hidden-input"
     accept=".gltf,.glb"

     onChange={(e) => {
       const file = e.target.files[0];
       if (file && fileValidation(file)) {
         setState((prev) => ({
           ...prev,
           selectedGltfFile: file,
         }));
         setSelected3DFileName(file.name);
       } else {
         e.target.value = "";
       }
     }}
   />
   <label htmlFor="dicom3DInput" className="browse-button">
     📄 Browse
   </label>
   {selected3DFileName && (
     <p className="file-name-display">Selected: {selected3DFileName}</p>
   )}
 </div> */}
 
 {/* Upload Report */}
 <div className="form-group">
   <label>Report (.pdf/.docx/.jpg/.png):</label>
   <input
     type="file"
     id="reportFileInput"
     accept=".pdf,.docx,.jpg,.jpeg,.png"
     className="hidden-input"
     onChange={(e) => {
       const file = e.target.files[0];
       if (file) {
         // Corrected file validation for .pdf and .docx
         const allowedExtensions = /(\.pdf|\.docx|\.jpg|\.png)$/i;
         if (!allowedExtensions.test(file.name)) {
           toast.error("Invalid file type. Please upload a .pdf or .docx file.", {
             position: "top-center",
           });
           e.target.value = ""; // Clear the input if validation fails
           return;
         }
         // If valid, update state
         setState({
           ...state,
           selectedReportFile: file,
         });
         setSelectedReportFileName(file.name); // Set the file name
       }
     }}
   />
   <label htmlFor="reportFileInput" className="browse-button">
     📄 Browse
   </label>
     {selectedReportFileName && (
     <p className="file-name-display">Selected: {selectedReportFileName}</p>
   )}
 </div>
               {/* Buttons */}
               <div className="form-buttons">
                 <button
                   type="button"
                   className="save-btn"
                   onClick={(e) => {
                     handleSave(e);
                     // Reset modal-related fields only
                     setState((prevState) => ({
                       ...initialState, // Reset upload-specific fields
                       FullName: prevState.FullName, // Preserve patient-specific details
                       Age: prevState.Age,
                       Gender: prevState.Gender,
                       ID: prevState.ID,
                       ClinicalHistory: prevState.ClinicalHistory, // Preserve Clinical History
                       Clinical_Textarea: prevState.Clinical_Textarea, // Preserve clinical history text
                       Clinical_Filepath: prevState.Clinical_Filepath, // Preserve clinical file path
                     }));
                     setShowUploadModal(false); // Close modal after save
                   }}
                 >
                   {selectedUploadID ? "Update" : "Save"}
                 </button>
                 <button
                   type="button"
                   className="cancel-btn"
                   onClick={() => {
                     setSelectedDicomFolderName(null); // Clear folder name
                     setSelected3DFileName(null); // Clear 3D file name
                     setSelectedReportFileName(null); // Clear report file name
                     // Reset modal-related fields only
                     setState((prevState) => ({
                       ...initialState, // Reset upload-specific fields
                       FullName: prevState.FullName, // Preserve patient-specific details
                       Age: prevState.Age,
                       Gender: prevState.Gender,
                       ID: prevState.ID,
                       ClinicalHistory: prevState.ClinicalHistory, // Preserve Clinical History
                       Clinical_Textarea: prevState.Clinical_Textarea, // Preserve clinical history text
                       Clinical_Filepath: prevState.Clinical_Filepath, // Preserve clinical file path
                     }));
                        resetModalFields();
                     setShowUploadModal(false); // Close modal on cancel
                   }}
                 >
                   Cancel
                 </button>
               </div>
             </form>
           </div>
         </div>
       )}
 
       {/* Toast Notifications */}
       <ToastContainer />
    
 
     </div>
   );
 }
 
 export default AddImage;